import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import DinasPenetapanKonfirmasi from 'app/KinerjaDinasPage/pages/penetapan/kirim/Konfirmasi'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import PageGuardDinas from 'app/KinerjaDinasPage/components/PageGuardDinas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardPenetapan } from 'app/KinerjaDinasPage/components/PageGuardPenetapan'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled =
      (toggle?.['kinerja-dinas-enabled'] &&
        toggle?.['kinerja-dinas-penetapan-enabled']) ||
      false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = () => {
  return (
    <PageGuardDinas>
      <PageGuardPenetapan>
        <DinasPenetapanKonfirmasi />
      </PageGuardPenetapan>
    </PageGuardDinas>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
  printablePage: true,
}

export default Page
